import { useTheme } from "./theme"
import { getAvatarColor, getBadgeColors } from "../lib/colors"

type AvatarProps = {
  id: string
  name?: string | null
  email?: string | null
  image?: string | null
  size?: "xs" | "sm" | "md" | "lg"
  className?: string
  title?: string
}

const SIZE_CLASSES: Record<NonNullable<AvatarProps["size"]>, { box: string; text: string }> = {
  xs: { box: "h-5 w-5", text: "text-[9px]" },
  sm: { box: "h-6 w-6", text: "text-[10px]" },
  md: { box: "h-10 w-10", text: "text-sm" },
  lg: { box: "h-24 w-24", text: "text-2xl" },
}

export function Avatar({ id, name, email, image, size = "sm", className = "", title }: AvatarProps) {
  const { theme } = useTheme()
  const { box, text } = SIZE_CLASSES[size]
  const displayName = name || email || id
  const initial = (displayName)[0]?.toUpperCase() ?? "?"
  const color = getAvatarColor(id)
  const { bg, text: textColor } = getBadgeColors(color, theme)

  if (image) {
    return (
      <div
        className={`${box} flex items-center justify-center overflow-hidden rounded-full ${className}`}
        title={title ?? displayName}
      >
        <img src={image} alt={displayName} className="h-full w-full object-cover" />
      </div>
    )
  }

  return (
    <div
      className={`${box} flex items-center justify-center rounded-full font-semibold ${text} ${className}`}
      style={{ backgroundColor: bg, color: textColor }}
      title={title ?? displayName}
    >
      {initial}
    </div>
  )
}
